var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1412_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00014 16.5C7.51678 16.5 6.06673 16.0601 4.83336 15.236C3.6 14.4119 2.6387 13.2406 2.07104 11.8701C1.50339 10.4997 1.35486 8.99168 1.64425 7.53683C1.93364 6.08197 2.64795 4.7456 3.69684 3.6967C4.74573 2.64781 6.08211 1.9335 7.53696 1.64411C8.99182 1.35472 10.4998 1.50325 11.8703 2.07091C13.2407 2.63856 14.4121 3.59986 15.2362 4.83323C16.0603 6.06659 16.5001 7.51664 16.5001 9C16.5001 10.9891 15.71 12.8968 14.3034 14.3033C12.8969 15.7098 10.9893 16.5 9.00014 16.5ZM9.00014 15C10.1868 15 11.3469 14.6481 12.3336 13.9888C13.3203 13.3295 14.0893 12.3925 14.5434 11.2961C14.9975 10.1997 15.1164 8.99335 14.8849 7.82946C14.6533 6.66558 14.0819 5.59648 13.2428 4.75736C12.4037 3.91825 11.3346 3.3468 10.1707 3.11529C9.0068 2.88378 7.8004 3.0026 6.70404 3.45673C5.60768 3.91085 4.67061 4.67989 4.01132 5.66658C3.35203 6.65328 3.00014 7.81331 3.00014 9C3.00014 10.5913 3.63228 12.1174 4.7575 13.2426C5.88272 14.3679 7.40884 15 9.00014 15ZM8.25014 11.25H9.75014V12.75H8.25014V11.25ZM8.25014 5.25H9.75014V9.75H8.25014V5.25Z",
    fill: "#8295B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1412_3541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.47f67579a11f7b0de56d18352b595bc6.svg";
export { ForwardRef as ReactComponent };